module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_header_2_m-5ce669394dbad6d862366e86150b13fd.webp";